var map = {
	"./banner-home-1.jpg": 386,
	"./banner-home-2.jpg": 387,
	"./banner-home.jpg": 388,
	"./benedict-1.jpg": 389,
	"./benedict-2.jpg": 390,
	"./benedict-3.jpg": 391,
	"./benedict-4.jpg": 392,
	"./benedict-5.jpg": 393,
	"./benedict-cover.jpg": 394,
	"./bistecca-1.jpg": 395,
	"./bistecca-2.jpg": 396,
	"./bistecca-3.jpg": 397,
	"./bistecca-4.jpg": 398,
	"./bistecca-cover.jpg": 399,
	"./bottled_cocktails.jpg": 400,
	"./caffe-milano-1.jpg": 401,
	"./caffe-milano-2.jpg": 402,
	"./caffe-milano-3.jpg": 403,
	"./caffe-milano-4.jpg": 404,
	"./caffe-milano-cover.jpg": 405,
	"./cake.jpg": 406,
	"./cocktail.jpg": 407,
	"./cs-1.jpg": 408,
	"./cs-2.jpg": 409,
	"./cs-3.jpg": 410,
	"./cs-4.jpg": 411,
	"./cs-cover.jpg": 412,
	"./cscc-1.jpg": 413,
	"./cscc-2.jpg": 414,
	"./cscc-3.jpg": 415,
	"./cscc-4.jpg": 416,
	"./cscc-5.jpg": 417,
	"./cscc-6.jpg": 418,
	"./cscc-cover.jpg": 419,
	"./home_delivery.jpg": 420,
	"./homedelivery.jpg": 421,
	"./loewy logo-04.png": 422,
	"./loewy-1.jpg": 423,
	"./loewy-2.jpg": 424,
	"./loewy-3.jpg": 425,
	"./loewy-cover.jpg": 426,
	"./pierre-1.jpeg": 427,
	"./pierre-2.jpeg": 428,
	"./pierre-3.jpeg": 429,
	"./pierre-4.jpeg": 430,
	"./pierre-5.jpeg": 431,
	"./pierre-cover.jpeg": 432,
	"./pizza-milano-1.jpg": 433,
	"./pizza-milano-2.jpg": 434,
	"./pizza-milano-3.jpg": 435,
	"./pizza-milano-4.jpg": 436,
	"./pizza-milano-cover.jpg": 437,
	"./roma-1.jpeg": 438,
	"./roma-1.jpg": 439,
	"./roma-2.jpeg": 440,
	"./roma-2.jpg": 441,
	"./roma-3.jpeg": 442,
	"./roma-3.jpg": 443,
	"./roma-4.jpeg": 444,
	"./roma-cover.jpeg": 445,
	"./shiraz_package.jpg": 446,
	"./spirit.jpg": 447,
	"./the-dutch-1.jpg": 448,
	"./the-dutch-2.jpg": 449,
	"./the-dutch-3.jpg": 450,
	"./the-dutch-4.jpg": 451,
	"./the-dutch-5.jpg": 452,
	"./the-dutch-6.jpg": 453,
	"./the-dutch-7.jpg": 454,
	"./the-dutch-cover.jpg": 455,
	"./tugwecare.jpg": 456,
	"./union-1.jpg": 457,
	"./union-2.jpg": 458,
	"./union-3.jpg": 459,
	"./union-4.jpg": 460,
	"./union-cover.jpg": 461,
	"./wine.jpg": 462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 385;